import { Link } from "@tanstack/react-router";

import { Button, Heading } from "@/ui";

export const ResumeError = () => {
  return (
    <div className="flex w-full flex-1 justify-center bg-canvas">
      <section className="flex max-w-xl flex-col items-center justify-center gap-6 px-6">
        <Heading className="text-2xl sm:text-3xl" level={1}>
          We could not resume your profile
        </Heading>
        <p className="text-lg text-content-secondary">
          The link may have expired or your profile was already completed. Please start a new
          profile or login to continue.
        </p>
        <div className="mt-4 flex gap-3">
          <Button asChild>
            <Link to="/profiling">Start New Profile</Link>
          </Button>
          <Button variant="secondary-dark" asChild>
            <Link to="/login">Go to Login</Link>
          </Button>
        </div>
      </section>
    </div>
  );
};
